<template>
  <main>
    <section id="triggerInfo">
        <div id="Navn" >
            <h2>Navn*</h2>
            <input type="text" lable="Navn">
        </div>
        <div id="procesNavn">
            <h2>Proces Navn*</h2>
            <select>
                <option value="">Proces 1 </option>
                <option value="">Proces 2 </option>
                <option value="">Proces 3 </option>
                <option value="">Proces 4 </option>
            </select>
        </div>
        <div >
            <h2>Job Prioritet*</h2>
            <select>
                <option value="">1</option>
                <option value="">2</option>
                <option value="">3</option>
                <option value="">4</option>
            </select>
        </div>
        <div>
            <h2>Runtimer Type*</h2>
            <select>
                <option value="">1</option>
                <option value="">2</option>
                <option value="">3</option>
                <option value="">4</option>
            </select>
        </div>
    </section>
    <section id="kategorier">

    </section>
    <section id="TriggerMaskine">
        <button
          :class="{'active': true}"
      
        >Execution Target</button>
        <button
         
        >Arguments</button>
        <h2>Tildel dynamisk</h2>
        <p>Udfør procestider<span><input type="text"></span>gange</p>
        <div>
            <h2>Robot konto</h2>
            <select>
                <option value="">1</option>
                <option value="">2</option>
                <option value="">3</option>
                <option value="">4</option>
            </select>
        </div>
        <div>
            <h2>Maskine</h2>
            <select>
                <option value="">1</option>
                <option value="">2</option>
                <option value="">3</option>
                <option value="">4</option>
            </select>
        </div>
    <p></p>
    </section>    
    <section id="triggerTid">
        <div id="tidZone">
            <h2>Tidzone*</h2>
            <select>
                <option value="">(UTC+01:00) København, Paris, Marid</option>
                <option value="">2</option>
                <option value="">3</option>
                <option value="">4</option>
            </select>
        </div>
        <div id="frekvens">
            <h2>Frekvens</h2>
            <select>
                <option value="">hver time</option>
                <option value="">2</option>
                <option value="">3</option>
                <option value="">4</option>
            </select>
        </div>
        <p>Gentag hver <span><input type="text">time(r)</span><span><input type="text"></span>gange</p>
        <div id="frekvens">
            <h2>Kalender restriktioner</h2>
            <select>
                <option value="">Ingen kalender valgt</option>
                <option value="">2</option>
                <option value="">3</option>
                <option value="">4</option>
            </select>
        </div>
        <div class="checkbox">
          <input type="checkbox">
          <p>Planlæg afslutning af jobudsættelse</p>
        </div>
    </section>
    <section class="form-row">
      <div>
        <!-- Dropdown to select start/stop with dynamic options and v-model -->
        <select v-model="jobStatus">
          <option :value="null">Stop</option>
          <option value="start">Start</option>
        </select>
      </div>
      <div>Et job efter</div>
      <div>
        <!-- Dropdown to select numbers 0-4 using v-for -->
        <select v-model="jobAfter1">
          <option v-for="number in options" :key="number" :value="number">{{ number }}</option>
        </select>
      </div>
      <div>
        <select v-model="jobAfter2">
          <option v-for="number in options" :key="number" :value="number">{{ number }}</option>
        </select>
      </div>
    </section>
          <section>
          <div class="checkbox">
            <input type="checkbox">
            <p>Planlæg automatisk lukning af job, hvis jobbet ikke stopper</p>
          </div>
          <div class="checkbox">
            <input type="checkbox">
            <p>Planlæg deaktivering af automatiseringsudløser</p>
          </div>
          <div class="checkbox">
            <input type="checkbox">
            <p>Generer en advarsel, hvis jobbet sidder fast i afventende eller genoptaget status</p>
          </div>
          <div class="checkbox">
            <input type="checkbox">
            <p>Generer en advarsel, hvis jobbet startede og ikke er afsluttet</p>
          </div>
          <div class="checkbox">
            <input type="checkbox">
            <p>Indstil udførelsesbaseret trigger deaktivering</p>
          </div>
        </section>

    </main>
</template>

<script>
</script>


<style lang="scss" scoped>
.form-row {
  display: flex;
  align-items: center; /* Aligns items vertically */
  gap: 10px; /* Adds space between the elements */

  select {
    padding: 5px;
  }
  div {
    display: flex;
    align-items: center; /* Ensures the text stays vertically aligned with the selects */
  }
}
main {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 50px 200px;
  padding: 20px;

  h2 {
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 8px;
  }

  input[type="text"], select, button {
    width: 100%;
    padding: 8px;
    border: 1px solid #555555;
    border-radius: 2px;
    font-size: 14px;
  }

  /* General input styles */
  input[type="text"], select {
    margin-top: 4px;
    box-sizing: border-box;
  }

  /* Section layout */
  #triggerInfo, #triggerTid, #TriggerMaskine {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
  }
  #Navn{
    grid-column: 1/span 2;
  }
  
  #procesNavn{
    grid-column: 1/span 2;
  }

  .checkbox{
    display: flex;

    p{
      margin-left: 10px;
    }
  }
  /* Specific category buttons */
  #kategorier {
    grid-row: 2;
    display: flex;
    flex-wrap: wrap;
    gap: 10px;

    button {
      padding: 8px 16px;
      background-color: #f0f0f0;
      border: 1px solid #ccc;
      cursor: pointer;
      border-radius: 4px;
    }

    button:hover {
      background-color: #e0e0e0;
    }
  }

  /* Targeting Execution section with arguments */
  #TriggerMaskine {
    grid-row: 3;
    grid-template-columns: 1fr 1fr;
    gap: 20px;

    button{
      cursor: pointer;
      text-align: left; /* or right, or initial */
      background-color: white;
      border: none;
      width: 150px;
      margin: 0;
      padding: 0;
    }

    .active {
      background-color: #7b181b31;
      color: #970000;
      font-weight: 900;
    }

    p {
      grid-column: 1 / 3;
      display: flex;
      align-items: center;
    }

    span {
      margin-left: 10px;
    }
  }

  /* Alignment for "Execution Target" section */
  #executionTarget {
    color: #b04646;
    font-weight: bold;
    grid-column: 1 / 3;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;

    .arguments {
      color: #777;
    }
  }

  /* Frequency input styling */
  #triggerTid {
    p {
      display: flex;
      align-items: center;
      gap: 10px;
    }

    #tidZone, #frekvens{
        grid-column: 1/span 2;
    }

    input[type="text"] {
      width: 60px;
      margin-right: 5px;
    }
  }

  /* Calendar restrictions and job ending controls */
  .checkbox-group {
    grid-column: 1 / 3;
    display: flex;
    flex-direction: column;
    gap: 10px;

    label {
      display: flex;
      align-items: center;
    }

    input[type="checkbox"] {
      margin-right: 10px;
    }
  }

  /* Job Ending Options */
  .job-ending {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  /* Full-width styling for certain sections */
  .full-width {
    grid-column: 1 / 3;
  }
}
</style>